import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaUserFriends, FaInstagram } from 'react-icons/fa';
import { GiTeacher, GiFamilyTree, GiGraduateCap } from 'react-icons/gi';
import { MdPsychology, MdGroups } from 'react-icons/md';
import './SolutionsSection.css';

const solutions = [
  {
    icon: <MdPsychology />,
    title: "General Counselling",
    desc: "Support for managing academic stress, exam fear, peer pressure, and screen addiction. General Counselling for Mental & Emotional Wellbeing. This is done by organising monthly sessions to tackle stress, self-doubt, and peer pressure, screen dependency with the aim to boost confidence, focus, and positivity in students."
  },
  {
    icon: <GiGraduateCap />,
    title: "Career Counselling (Class 6–12)",
    desc: "We help in organising counselling sessions with clear aim to choose the right career path, be it engineering, medicine, commerce, or liberal arts. We offer structured, age-appropriate career counselling sessions that introduce students to competitive exam pathways, emerging careers, aptitude mapping, and smart goal-setting."
  },
  {
    icon: <GiFamilyTree />,
    title: "Parental Counselling",
    desc: "Regular interactions to educate parents on changing exam patterns, career paths, emotional support, and reducing their over-dependence on tuition culture. Parental Counselling & Orientation Programs. We educate parents about changing career landscapes, how to support their child emotionally and academically, and how to avoid the coaching trap—making school, not tuition, the centre of learning. Outcome: Informed, confident students and cooperative, empowered parents."
  },
  {
    icon: <MdGroups />,
    title: "Parent-School-Student Model",
    desc: "Workshops, webinars, and in-person sessions to build trust, transparency, and loyalty among parents—turning them into long-term ambassadors of your school."
  },
  {
    icon: <FaUserFriends />,
    title: "Student Empowerment Workshops",
    desc: " Helping students discover their strengths, become confident speakers, and take pride in representing their school.We aim to make every student a brand ambassador of your school by building deep emotional and academic engagement through these counselling services."
  },
  {
    icon: <FaInstagram />,
    title: "Hyper-local Digital Branding",
    desc: "In this digital era, word-of-mouth has moved online, and your school’s presence on platforms like Instagram, YouTube, and Facebook is not just optional—it’s essential. Therefore, in today’s connected world, school marketing activities must include local digital presence."
  }
];

function SolutionsSection() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (

    <div className="solutions-section" id="services">
      <Container>
        <h2 className="solutions-title text-center" data-aos="fade-up">
          Complete Counselling Ecosystem for Schools
        </h2>
        <p className="solutions-subtitle text-center" data-aos="fade-up" data-aos-delay="100">
          The Missing Backbone in Schooling: Empowering Students, Parents, and Schools Together
        </p>
        <div className="timeline">
          {solutions.map((item, idx) => (
            <div
              className="timeline-item"
              key={idx}
              data-aos="fade-up"
              data-aos-delay={idx * 150}
            >
              <div className="timeline-icon">{item.icon}</div>
              <div className="timeline-content">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
}

export default SolutionsSection;
